import { forEach, keys, omit, pick } from 'lodash';
import VendorFileFields from '../../Constants/vendor-file-fields';
/**
 *  Sets up the values of the form to be passed to state. Populates fields
 * already completed by the user or that have already been saved in the db.
 *
 *  @param {object} vendor the vendor object returned to the Vendor Application
 *
 *  @returns {object} form data from the vendor record in the db.
 */
export default function setupInfluencerForm(influencer) {
  const form = omit(influencer, [
    'entity_id',
    'internal_id',
    'bank_account_type',
    'rejection_reason',
    'type',
    'top_sample_acknowledgement',
    'payment_file_format',
    'application_status',
    'application_archived_at',
    'is_children_clothing',
    'factory_compliance_report',
    'fcr_expiration',
    'third_party_garment',
    'custentity_fn_mh_prop65_test',
    'banking_request_rejection_reason',
    'banking_request_status',
    'top_sample_acknowledgement',
    'printing_onboarding',
    'init_counter_email_sent_at',
    'domestic_merch_po_eligible',
    'inactive',
  ]);

  const files = pick(influencer, keys(VendorFileFields));

  forEach(files, (_, key) => {
    form[key] = files[key].exists;
  });

  return form;
}
